import React from 'react';
import { useTranslation } from 'react-i18next';
import { Award, BookOpen } from 'lucide-react';
import { SectionHeading } from '../shared/SectionHeading';

export const StatsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="stats" className="section-shell">
      <div className="section-container">
        <SectionHeading
          eyebrow={t('landing.stats.eyebrow')}
          title={t('landing.stats.headingClean')}
        />

        <p className="mx-auto mt-4 max-w-2xl text-center text-sm text-slate-500">
          {t('common.independenceDisclaimer')}
        </p>

        <div className="mx-auto mt-12 grid max-w-4xl grid-cols-1 gap-5 md:grid-cols-2">
          <div className="surface-card-soft p-7 text-center">
            <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
              <BookOpen className="h-7 w-7 text-primary" />
            </div>
            <p className="text-4xl font-bold text-ink">4</p>
            <p className="mt-2 text-sm font-medium uppercase tracking-[0.1em] text-slate-600">
              {t('landing.stats.examSections')}
            </p>
          </div>
          <div className="surface-card-soft p-7 text-center">
            <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-secondary/10">
              <Award className="h-7 w-7 text-secondary" />
            </div>
            <p className="text-4xl font-bold text-ink">A2 &amp; B1</p>
            <p className="mt-2 text-sm font-medium uppercase tracking-[0.1em] text-slate-600">
              {t('landing.stats.levels')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
